import { UploadModalContext } from "@/components/UploadModal/UploadModalProvider";
import { useContext } from "react";

export function useUploadModal() {
  const context = useContext(UploadModalContext);
  if (context === undefined) {
    throw new Error("useUploadModal must be used within a UploadModalProvider");
  }
  return context;
}
